import React from "react";
import { Icon } from "@commonsku/design-system";
import { Zap } from "lucide-react";
import {
  WorkflowAutomationModelType,
  WorkflowConditionInput,
} from "../../../types";
import { WorkflowConfigurationOptions } from "../catalog/configurationOptions";
import AutomationStepPanel from "./AutomationStepPanel";
import { getTriggerEditor } from "./trigger-editors/triggerEditorRepository";

export interface TriggerStepProps {
  modelType: WorkflowAutomationModelType;
  trigger: WorkflowConditionInput | null | undefined;
  configurationOptions: WorkflowConfigurationOptions;
  onChange: (trigger: WorkflowConditionInput) => void;
}

const TriggerIcon = () => (
  <Icon ariaHidden as={Zap} boxSize="6">
    {null}
  </Icon>
);

/**
 * Trigger configuration panel.
 */
export const TriggerStep = ({
  modelType,
  trigger,
  configurationOptions,
  onChange,
}: TriggerStepProps) => {
  const TriggerEditor = trigger
    ? getTriggerEditor(trigger.type, trigger.operator)
    : undefined;
  const triggerOption = trigger
    ? configurationOptions.trigger_options.find(
        (option) =>
          option.model_type === modelType &&
          option.type === trigger.type &&
          option.operator === trigger.operator,
      )
    : undefined;

  return (
    <AutomationStepPanel icon={<TriggerIcon />} stepNumber={1} title="Triggers">
      {TriggerEditor && trigger && triggerOption && (
        <TriggerEditor
          modelType={modelType}
          onChange={onChange}
          option={triggerOption}
          trigger={trigger}
        />
      )}
    </AutomationStepPanel>
  );
};

export default TriggerStep;
